import { ButtonProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Valve } from '../types'
import { LoadingButton } from '@mui/lab'
import { useDispatch } from 'react-redux'
import { createErrorNotification, createSuccessNotification } from '../redux/slices/notifications'
import { useState } from 'react'
import { updateValve } from '../services/valve'

export interface ValveDetachHeaterButtonProps extends Omit<ButtonProps, 'onClick'> {
  valve: Valve
  afterSubmit?: (valve: Valve) => void
}

export default function ValveDetachHeaterButton({
  valve,
  afterSubmit,
  children,
  ...props
}: ValveDetachHeaterButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('valve')

  /**
   * The dispatch function.
   */
  const dispatch = useDispatch()

  /**
   * The submitting state.
   */
  const [isSubmitting, setSubmitting] = useState<boolean>(false)

  /**
   * Handle the submit action.
   */
  async function handleSubmit() {
    try {
      setSubmitting(true)

      const updatedValve = await updateValve(valve.name, {
        heater: null
      })

      dispatch(createSuccessNotification(t('detachHeaterSuccess')))

      afterSubmit?.(updatedValve)
    } catch (_) {
      dispatch(createErrorNotification(t('detachHeaterError')))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      {valve?.heaterId !== null && (
        <LoadingButton
          variant="contained"
          color="warning"
          {...props}
          loading={isSubmitting}
          onClick={handleSubmit}
        >
          {children ?? t('detachHeater')}
        </LoadingButton>
      )}
    </>
  )
}
